import React from 'react';
import { Leaf, Sparkles } from 'lucide-react';
import { Section, Button, OrganicDivider } from './ui';
const RECIPES = ['Hipertensión', 'Diabetes', 'Obesidad', 'Menopausia', 'Várices', 'Celulitis', 'Caída del cabello', 'Flacidez', 'Hongos', 'Endometriosis', 'Depresión', 'Ansiedad', 'Sinusitis', 'Asma', 'Artritis', 'Enfermedad renal crónica', 'Enfermedad pulmonar crónica', 'Osteoporosis', 'Dolores musculares'];
export const RecipesShowcase = () => {
  return <>
      <OrganicDivider type="wave" color="fill-cream" data-id="element-87" />
      <Section bg="beige" className="pt-8 relative overflow-hidden" data-id="element-88">
        {/* Decorative floating leaves */}
        <Leaf className="absolute top-20 left-8 text-herbal/10 w-24 h-24 -rotate-12 hidden md:block" data-id="element-89" />
        <Leaf className="absolute bottom-32 right-10 text-gold/15 w-32 h-32 rotate-45 hidden md:block" data-id="element-90" />

        <div className="text-center max-w-3xl mx-auto mb-12 relative z-10" data-id="element-91">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-herbal/10 text-herbalDark text-sm font-bold mb-4" data-id="element-92">
            <Sparkles size={16} data-id="element-93" />
            <span data-id="element-94">Lista de Recetas</span>
          </div>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-petroleum mb-4" data-id="element-95">
            Mira algunas de las preparaciones{' '}
            <span className="italic text-herbalDark" data-id="element-96">
              naturales que recibirás
            </span>
          </h2>
          <p className="text-lg text-gray-600" data-id="element-97">
            Estas son solo{' '}
            <span className="font-bold text-petroleum" data-id="element-98">algunas</span> de las más
            de <span className="font-bold text-herbalDark" data-id="element-99">970 recetas</span>{' '}
            que tendrás disponibles desde el primer día.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 relative z-10" data-id="element-100">
          {RECIPES.map((recipe, i) => <div key={i} className="group bg-white p-5 rounded-2xl border border-gray-100 shadow-sm hover:shadow-md hover:border-herbal/40 transition-all duration-300 flex items-center gap-4" data-id="element-101">
              <div className="w-12 h-12 rounded-xl bg-herbal/10 flex items-center justify-center shrink-0 group-hover:bg-herbal/20 transition-colors" data-id="element-102">
                <Leaf className="text-herbal" size={22} data-id="element-103" />
              </div>
              <div className="flex-1 min-w-0" data-id="element-104">
                <p className="text-xs text-gray-400 font-medium tracking-wider mb-0.5" data-id="element-105">
                  RECETA #{String(i + 1).padStart(2, '0')}
                </p>
                <p className="font-bold text-petroleum leading-snug" data-id="element-106">
                  Remedio natural para {recipe.toLowerCase()}
                </p>
              </div>
            </div>)}

          {/* Teaser card */}
          <div className="bg-petroleum text-white p-5 rounded-2xl border-2 border-gold/40 shadow-glow-gold flex items-center gap-4 relative overflow-hidden" data-id="element-107">
            <div className="absolute -right-6 -top-6 text-7xl font-heading font-bold text-gold/10" data-id="element-108">
              +
            </div>
            <div className="w-12 h-12 rounded-xl bg-gold/20 flex items-center justify-center shrink-0" data-id="element-109">
              <Sparkles className="text-gold" size={22} data-id="element-110" />
            </div>
            <div className="flex-1 relative z-10" data-id="element-111">
              <p className="text-xs text-gold font-medium tracking-wider mb-0.5" data-id="element-112">
                Y MUCHO MÁS
              </p>
              <p className="font-bold text-white leading-snug" data-id="element-113">
                +950 recetas adicionales esperándote
              </p>
            </div>
          </div>
        </div>

        <div className="text-center mt-12 relative z-10" data-id="element-114">
          <Button size="lg" className="shadow-glow-herbal" data-id="element-115">
            🌿 QUIERO ACCEDER A TODAS LAS RECETAS
          </Button>
          <p className="text-sm text-gray-500 mt-3 italic" data-id="element-116">
            Acceso inmediato · Garantía de 7 días
          </p>
        </div>
      </Section>
    </>;
};